import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
  connect() {
    this.setUpDatePickers();
  }

  setUpDatePickers() {    
    const togglePlaceholder = ($input) => {
      const $wrapper = $input.closest('.course-dates__input-wrapper');
      const $placeholder = $wrapper.find('.course-dates__placeholder');
      if ($input.val()) {
        $placeholder.hide();
      } else {
        $placeholder.show();
      }
    }

    const $startDate = $('.js-datepicker-start');
    const $endDate = $('.js-datepicker-end');

    $('.js-datepicker-start').datepicker('destroy').datepicker({
      dateFormat: "M d, yy",
      minDate: new Date(),
      onSelect: function() {
        const start = $(this).datepicker("getDate");
        $endDate.datepicker("option", "minDate", start);
        togglePlaceholder($(this));
      }
    });

    $('.js-datepicker-end').datepicker('destroy').datepicker({
      dateFormat: "M d, yy",
      minDate: new Date(),
      onSelect: function() {
        const end = $(this).datepicker("getDate");
        $startDate.datepicker("option", "maxDate", end);
        togglePlaceholder($(this));
      }
    });

    togglePlaceholder($startDate);
    togglePlaceholder($endDate);
  }
}
